import React, { MouseEventHandler } from "react";
import styled from "styled-components";
import { Button, Theme, colors } from "@literati/public-ui-shared-react";

const QUESTION: Record<Variant, string> = {
  createAccount: "Already have an account?",
  login: "New to Literati?",
};
const BUTTON_TEXT: Record<Variant, string> = {
  createAccount: "Log In",
  login: "Sign Up",
};

const CLASS_BASE = "auth-form-toggle";
export const AuthFormToggleClassName = {
  BASE: CLASS_BASE,
  BUTTON: `${CLASS_BASE}-button`,
} as const;

export type Variant = "createAccount" | "login";

export interface AuthFormToggleProps {
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  variant: Variant;
}

export const StyledP = styled.p`
  margin: 2rem 0 0;
  padding: 2rem 0 0;
  border-top: 1px solid ${colors.newsprint3};
  text-align: center;
`;

export const AuthFormToggle = ({
  className = "",
  onClick,
  variant,
}: AuthFormToggleProps) => {
  const cls = AuthFormToggleClassName;

  const question = QUESTION[variant];
  const buttonText = BUTTON_TEXT[variant];

  return (
    <Theme>
      <StyledP className={`${cls.BASE} ${className}`}>
        {question}{" "}
        <Button
          className={cls.BUTTON}
          css="text-decoration: none !important"
          onClick={onClick}
          type="button"
          variant="link"
        >
          {buttonText}
        </Button>
      </StyledP>
    </Theme>
  );
};

export default AuthFormToggle;
